export default __webpack_public_path__ + "static/media/foodle-design04.ffb02128.jpg";